import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import TopNav from '../containers/navs/Topnav';
import Sidebar from '../containers/navs/Sidebar';
import Mainmenu from '../containers/navs/Mainmenu';
import IconMenu from '../containers/navs/IconMenu';
import {
  AxiosAPI,
  getUserID,
  getGroupID,
  getUserRole,
  getPropertyId,
  setPropertyId,
} from '../helpers/AxiosAPI';
import {
  gAPI_Users_By_Id,
  gAPI_Property_List_By_Group,
} from '../constants/APIs';
import {
  changeUser,
  changeUserName,
  changeProperty,
  ChangeMymaSuperAdmin,
  changePropertyTags,
  ChangeUserSuperAdmin,
  ChangeRolePermission
} from '../redux/actions';
class AppLayout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      role: 'Admin',
      renderNav: false,
      propertyList: [],
      propertyId: '',
      userData: undefined,
      isIconMenu: false, // ✅ MainMenu by default
    };
  }
  updateBodyClass = () => {
    const { isIconMenu } = this.state;
    const { serviceProvider } = this.props;

    const isSidebar =
      serviceProvider === '2' || serviceProvider === '5';

    // Always clean first
    document.body.classList.remove('with-main-menu', 'with-icon-menu');

    if (!isSidebar) {
      if (isIconMenu) {
        document.body.classList.add('with-icon-menu');
      } else {
        document.body.classList.add('with-main-menu');
      }
    }

    window.dispatchEvent(new Event('resize'));
  };

  componentDidMount() {
    this.updateBodyClass();
    AxiosAPI({
      method: 'get',
      url: `${gAPI_Users_By_Id}/${getUserID()}?gid=${getGroupID()}`,
    })
      .then((res) => {
        this.props.changeUser(res.data.email);
        this.props.changeUserName(res.data.fullName);
        this.setState({ userData: res.data });
        this.props.ChangeMymaSuperAdmin(res.data?.isMymaSuperAdmin);
        this.props.ChangeUserSuperAdmin(res.data?.isSuperAdmin);
        res.data.roles.forEach((r) => {
          if (r === 'Agent') {
            this.props.ChangeRolePermission("Agent");
          }
          if (r === 'User' && res.data.roles.length === 1) {
            this.setState({ role: 'User' });
          } else if (r === 'Agent' && res.data.roles.length === 1) {
            this.setState({ role: 'Agent' });
          }
        });

        AxiosAPI({
          method: 'get',
          url: `${gAPI_Property_List_By_Group}?group_id=${getGroupID()}`,
        })
          .then((pres) => {
            let property_id = getPropertyId() !== undefined &&
              getPropertyId() !== null &&
              getPropertyId().length > 0
              ? getPropertyId()
              : this.props.propertyId;
            // console.log(this.props.propertyId, 63);
            // setPropertyId();
            //console.log('property_id', property_id);
            // if (property_id === '-1') {
            //   property_id = ''
            // }
            let lstTags = [];
            pres.data.map((l) => {
              if (
                l.tagList !== undefined &&
                l.tagList !== null &&
                l.tagList.length > 0
              )
                l.tagList.map((t) => {
                  if (!lstTags.includes(t)) lstTags.push(t);
                });

            });
            this.props.changePropertyTags(lstTags);
            if (
              res.data.properties.length > 0 &&
              res.data.properties[0] === '-1'
            ) {
              const hotel = pres.data.find((elem) => {
                return elem.id === property_id;
              });

              if (hotel) {
              } else if (property_id === '-1') {
                property_id = '-1';
              } else if (!hotel && property_id !== '-1') {
                property_id = pres.data[0]?.id || '-1';
              } else {
                property_id = pres.data[0].id;
              }
              this.setState({
                propertyList: pres.data,
                propertyId: property_id,
              });
            } else {
              const finalResult = [];
              if (res.data?.isSuperAdmin && res.data.isSuperAdmin === true) {
                pres.data.forEach((p) => {
                  finalResult.push({
                    id: p.id,
                    name: p.name,
                    websiteLink: p.websiteLink,
                    rooms: p.rooms,
                    starRating: p.starRating,
                    type: p.type,
                    groupName: p.groupName,
                    isBmb: p.isBmb,
                    isAiva: p.isAiva,
                    isVirtualFrontDesk: p.isVirtualFrontDesk,
                    timeZone: p.timeZone,
                  });
                  //console.log(finalResult);
                });
              } else {
                pres.data.forEach((p) => {
                  res.data.properties.forEach((r) => {
                    if (p.id === r) {
                      finalResult.push({
                        id: p.id,
                        name: p.name,
                        websiteLink: p.websiteLink,
                        rooms: p.rooms,
                        starRating: p.starRating,
                        type: p.type,
                        groupName: p.groupName,
                        isBmb: p.isBmb,
                        isAiva: p.isAiva,
                        timeZone: p.timeZone,
                      });
                    }
                  });
                  //console.log(finalResult);
                });
              }

              const hotel = finalResult.find((elem) => {
                return elem.id === property_id;
              });

              if (hotel) {
              } else if (property_id === '-1') {
                property_id = '-1';
              } else if (!hotel && property_id !== '-1') {
                property_id = finalResult.length > 0 ? finalResult[0].id : '-1';
              } else property_id = '-1';

              // else if (finalResult.length > 0) {
              //   property_id = finalResult[0].id;
              // }

              //console.log(property_id, 137);
              this.setState({
                propertyList: finalResult,
                propertyId: property_id,
              });
            }
            this.props.changeProperty(property_id);
            this.setState({ renderNav: true });
          })
          .catch((err) => console.error(err));
      })
      .catch((err) => console.error(err));
  }
  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.isIconMenu !== this.state.isIconMenu ||
      prevProps.serviceProvider !== this.props.serviceProvider
    ) {
      this.updateBodyClass();
    }
  }

  toggleMenu = () => {
    this.setState((prevState) => ({
      isIconMenu: !prevState.isIconMenu,
    }));
  };

  render() {
    const { containerClassnames, serviceProvider } = this.props;
    const { isIconMenu } = this.state;
    const group = getGroupID();
    console.log('pid', this.state.propertyId);
    // console.log('serv', serviceProvider);
    return (
      <div id="app-container" className={containerClassnames}>
        {this.state.renderNav ? (
          <Fragment>
            <TopNav
              history={this.props.history}
              plist={this.state.propertyList}
              pid={this.state.propertyId}
              role={this.state.role}
              userData={this.state.userData}
              onMenuIconClick={this.toggleMenu}
              serviceProvider={serviceProvider}
            />
            {serviceProvider && serviceProvider !== '2' && serviceProvider !== '5' ? (
              isIconMenu ? (
                <IconMenu role={this.state.role} pid={this.state.propertyId} />
              ) : (
                <Mainmenu role={this.state.role} pid={this.state.propertyId} />
              )
            ) : (
              <Sidebar role={this.state.role} pid={this.state.propertyId} />
            )}
          </Fragment>
        ) : (
          <Fragment>
            <nav className="navbar fixed-top">
              <a className="navbar-logo" href="/">
                {
                  this.props.serviceProviderLogo !== undefined &&
                  this.props.serviceProviderLogo != null &&
                  this.props.serviceProviderLogo !== '' && (
                    <img
                      src={this.props.serviceProviderLogo}
                      width={1168 / 9}
                      height={158 / 2}
                      alt="logo"
                    />
                  )
                  // :
                  // <img src={logo} width={1168 / 9} height={158 / 2} alt="logo" />
                }
              </a>
            </nav>
            <div className="sidebar">
              <div className="main-menu"></div>
            </div>
          </Fragment>
        )}
        {serviceProvider && serviceProvider !== '2' && serviceProvider !== '5' ? (
          <div className="container-fluid menu-size">{this.props.children}</div>
        ) : (
          <main>
            <div className="container-fluid">{this.props.children}</div>
          </main>
        )}
      </div>
    );
  }
}

const mapStateToProps = ({ menu, settings }) => {
  const { containerClassnames } = menu;
  const { locale, propertyId, serviceProviderLogo, serviceProvider } = settings;
  return {
    containerClassnames,
    locale,
    propertyId,
    serviceProviderLogo,
    serviceProvider,
  };
};
const mapActionToProps = {
  changeUser,
  changeUserName,
  changeProperty,
  ChangeMymaSuperAdmin,
  changePropertyTags,
  ChangeUserSuperAdmin,
  ChangeRolePermission
};

export default withRouter(
  connect(mapStateToProps, mapActionToProps)(AppLayout)
);
